import { render, staticRenderFns } from "./ac-dynamic-kanban.vue?vue&type=template&id=51f4bcf9&scoped=true&"
import script from "./ac-dynamic-kanban.vue?vue&type=script&lang=js&"
export * from "./ac-dynamic-kanban.vue?vue&type=script&lang=js&"
import style0 from "./ac-dynamic-kanban.vue?vue&type=style&index=0&id=51f4bcf9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51f4bcf9",
  null
  
)

export default component.exports